import React from 'react';
import { connect, MapStateToProps } from 'react-redux';
import { Link } from 'react-router-dom';

import { ExtendedMatchEntity } from '../types';
import { ReduxState } from 'app/redux/types';

import { Icon, IconSize } from 'app/design-system/components/Icon';
import { SlotType } from 'app/lib/betting/betting-entities';
import {
  composeSportPath,
  composeTournamentPath,
  composeUnionPath,
  getPrefixBySlotType,
} from 'app/modules/Navigation/utils';
import { matches, sports, tournaments, tournamentUnions } from 'app/modules/Search/selectors';

import styles from './MatchItem.module.scss';

type StoreProps = {
  sportName?: string;
  tournamentUnionName?: string;
  tournamentName?: string;
  id?: number;
  sportId?: number;
  tournamentUnionId?: number;
  tournamentId?: number;
  tournamentStageId?: number;
  isFirst?: boolean;
  linkToLine?: boolean;
  slotType?: number;
};

type Props = {
  matchId: number;
} & StoreProps;

const chevronRightIcon = (
  <Icon icon="micro-chevron-right"
        size={IconSize.SMALL} />
);

const MatchSubHeader: React.FC<Props> = ({
  sportName,
  tournamentUnionName,
  tournamentName,
  id,
  sportId,
  tournamentUnionId,
  tournamentId,
  tournamentStageId,
  isFirst,
  linkToLine,
  slotType,
}) => {
  let pathname = slotType && getPrefixBySlotType(slotType);

  if (linkToLine) {
    pathname = getPrefixBySlotType(SlotType.PREMATCH);
  }

  return (
    <div className={styles.subHeader}>
      {(
        pathname
        && sportId
        && tournamentUnionId
        && tournamentId
        && tournamentStageId
        && id
        && isFirst
      ) && (
        <>
          <Link
            to={composeSportPath(
              { sportId },
              pathname,
            )}
            data-ga-event="search-crumbsClick"
            data-ga-event-value="sport"
            data-ga-sport-category={sportId}>
            {sportName}
          </Link>

          {chevronRightIcon}

          <Link
            to={composeUnionPath(
              { sportId, tournamentUnionId },
              pathname,
            )}
            data-ga-event="search-crumbsClick"
            data-ga-event-value="union"
            data-ga-sport-country={tournamentUnionId}>
            {tournamentUnionName}
          </Link>

          {chevronRightIcon}

          <Link
            to={composeTournamentPath(
              { sportId, tournamentUnionId, tournamentId },
              pathname,
            )}
            data-ga-event="search-crumbsClick"
            data-ga-event-value="tournament"
            data-ga-sport-league={tournamentId}>
            {tournamentName}
          </Link>
        </>
      )}
    </div>
  );
};

const mapStateToProps: MapStateToProps<
  StoreProps,
  Props,
  ReduxState
> = (state: ReduxState, { matchId }): StoreProps => {
  const match: ExtendedMatchEntity | undefined = matches(state).get(matchId);

  if (!match) {
    return {};
  }

  return {
    sportName: sports(state).get(match.sportId)?.name,
    tournamentUnionName: tournamentUnions(state).get(match.tournamentUnionId)?.name,
    tournamentName: tournaments(state).get(match.tournamentId)?.name,
    id: match.id,
    sportId: match.sportId,
    tournamentUnionId: match.tournamentUnionId,
    tournamentId: match.tournamentId,
    tournamentStageId: match.tournamentStageId,
    isFirst: match.isFirst,
    linkToLine: match.linkToLine,
    slotType: match.slotType,
  };
};

export default connect(mapStateToProps)(MatchSubHeader);
